import React from "react";

const Follow = (props: {[key: string]: any}) => {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
      <path d="M12.5 8.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5ZM8.5 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm-4-.25a.75.75 0 1 0-1.5 0v2H1a.75.75 0 0 0 0 1.5h2v2a.75.75 0 0 0 1.5 0v-2h2a.75.75 0 0 0 0-1.5h-2v-2Zm4.16 7.23c.86-.46 2.19-.73 3.84-.73s2.98.27 3.85.73c.79.42 1.15.96 1.15 1.7a.69.69 0 0 1-.05.3.33.33 0 0 1-.1.12c-.07.06-.25.15-.6.15h-8.5c-.35 0-.53-.1-.6-.16a.33.33 0 0 1-.1-.12.69.69 0 0 1-.05-.28c0-.75.36-1.3 1.16-1.71Zm3.84-2.23c-1.77 0-3.38.28-4.55.9S6 13.26 6 14.7c0 .69.27 1.22.69 1.56.4.34.95.5 1.55.5h8.52c.6 0 1.14-.16 1.55-.5.42-.34.69-.87.69-1.56 0-1.43-.78-2.42-1.95-3.04a9.96 9.96 0 0 0-4.55-.9Z"></path>
    </svg>
  );
};

export default Follow;
